<template>
	<div>
		<Popup
			v-model:show="friendRoomPop"
			position="bottom"
			closeable
			:close-on-click-overlay="false"
			:style="{ height: '600px' }">
			<div style="font-size: var(--base-px-14);font-weight: bold;text-align: center;padding-top: var(--base-px-15);">
				好友和群聊
			</div>
			<Divider/>
			<div class="friend_page">
				<div>Ta添加的员工({{ roomData.employeeName.length }})</div>
				<div v-for="(item,index) in roomData.employeeName" :key="index" style="margin-top: var(--base-px-15);">
					<div style="display: flex;cursor: pointer;" @click="$refs.employeePopup.show(item)">
						<img :src="item.avatar" alt="" style="width: var(--base-px-50);height: var(--base-px-50);">
						<div style="margin-left: var(--base-px-10);">
							<div style="color: #333;">{{ item.employeeName }}</div>
							<div style="color: #D0D0D0;font-size: var(--base-px-14);margin-top: var(--base-px-8);">添加时间：<span
								style="color: #595959;">{{ item.createTime }}</span></div>
						</div>
					</div>
					<Divider dashed/>
				</div>
				<div>Ta加入的群聊({{ roomData.roomName.length }})</div>
				<div
					class="friend_flex"
					style="margin-top: var(--base-px-15);padding: var(--base-px-15);background: #F9F9F9;"
					v-for="(item,index) in roomData.roomName"
					:key="index"
				>
					<div style="display: flex;">
						<img src="../../../assets/roomSvgImg.svg" alt="" style="width: var(--base-px-50);height: var(--base-px-50);">
						<div style="margin-left: var(--base-px-10);color: #D0D0D0;font-size: var(--base-px-14);">
							<div><span style="color: #4E4E4E;">{{ item.name }}</span></div>
							<div>群主：{{ item.ownerName }}</div>
							<div>入群时间：<span style="color: #4E4E4E;">{{ item.joinTime }}</span></div>
							<van-tag plain type="primary" size="medium" style="margin-top: var(--base-px-5);" v-if="item.isJoin==1">
								我已在群聊
							</van-tag>
							<van-tag plain type="danger" size="medium" style="margin-top: var(--base-px-5);" v-if="item.isJoin==0">
								我不在群聊
							</van-tag>
						</div>
					</div>
					<img src="../../../assets/copyImg.png" alt=""
					     style="width: var(--base-px-20);height: var(--base-px-20);margin-top: var(--base-px-20);margin-right: var(--base-px-10);cursor: pointer;"
					     @click="copyBtn(item)">
				</div>
				<div style="margin-top: var(--base-px-17);text-align: center;color: #8C8C8C;font-size: var(--base-px-14);">
					没有更多了
				</div>
			</div>
		</Popup>
		<input type="text" class="copy-input" ref="copyInput">
		<employeePopup ref="employeePopup"/>
	</div>
</template>
<script>
import employeePopup from '../components/employeePopup'
// eslint-disable-next-line no-unused-vars
import {setClipboardData} from '@/utils/wxCodeAuth'
import {Popup, Divider, Toast} from 'vant'

export default {
	components: {
		Popup, Divider, employeePopup
	},
	data() {
		return {
			friendRoomPop: false,
			roomData: {
				roomName: [],
				employeeName: []
			}
		}
	},
	methods: {
		async copyBtn(item) {
			Toast('复制成功')
			await setClipboardData(item.name)
		},
		show(roomData) {
			this.friendRoomPop = true
			this.roomData = roomData
		}
	}
}
</script>
<style scoped lang="less">
.friend_flex {
	display: flex;
	justify-content: space-between;
}

.friend_page {
	padding: 0 var(--base-px-35) var(--base-px-30) var(--base-px-35);
	font-size: var(--base-px-14);
	color: #6D6D6D;
}

.copy-input {
	width: var(--base-px-10);
	position: absolute;
	top: 0;
	left: 0;
	opacity: 0;
	z-index: -10;
}
</style>
